
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component
export default class AnswerBlockNoneOfAbove extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  input = "";

  isChecked = false;

  updateAnswer() {
    this.input = this.isChecked ? "None of the above" : "";

    SMQuestionnaire.setNoneOfTheAboveOptionSelected(this.isChecked);

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: this.input,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
      type: this.answerBlockData.type,
    });
  }

  changeAnswer() {
    if (this.index === null) return;

    this.isChecked = !this.isChecked;

    this.updateAnswer();
  }

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index != null && answer?.value) this.isChecked = answer.value === "None of the above";

    this.updateAnswer();

    if (this.isChecked) {
      setTimeout(() => {
        SMQuestionnaire.setCanGoNext(true);
      }, 50);
    }
  }
}
